// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ONBj","location":"Header_location__15koB"};